
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IDocument, IInBalanceCheck } from "@tylertech/tyler-api-types";

/**
 * InBalanceService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InBalanceService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetInBalanceCheck(providerId: string): Promise<IInBalanceCheck> {
        return this.$apiService.sendAuth("IInBalanceService/GetInBalanceCheck", providerId);
    }
    GetRegisteredChecks(): Promise<string[]> {
        return this.$apiService.sendAuth("IInBalanceService/GetRegisteredChecks");
    }
    GetReportDocument(providerId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IInBalanceService/GetReportDocument", providerId);
    }
}
